module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-feed-event-list-item"
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('div', {
    staticClass: "contact-event-subicon",
    class: _vm.event.emailSubiconClass()
  })]), _c('div', {
    staticClass: "title"
  }, [(_vm.event.contact.deleted_by_user_at) ? _c('div', {
    staticClass: "deleted-contact-name"
  }, [_vm._v(_vm._s(_vm.event.contact.full_name))]) : _c('div', {
    staticClass: "contact-name clickable",
    on: {
      "click": function($event) {
        return _vm.toggleTaskBar(_vm.event.contact)
      }
    }
  }, [_vm._v(_vm._s(_vm.event.contact.full_name))]), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.liveFeedEventDescription()))])]), _c('div', {
    staticClass: "created-at"
  }, [_vm._v(_vm._s(_vm.moment(_vm.event.created_at).format('LTS')))]), _c('div', {
    staticClass: "user"
  }, [_c('span', [_vm._v("Responsável:")]), _c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.event.user.name))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56ed74d3!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/live_feed_event_list_item.vue
// module id = 1128
// module chunks = 1